














































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardSkriningRisikoJatuh from "@/components/pemeriksaan/assesmen/skriningrisikojatuh/CardSkriningRisikoJatuh.vue";
import AsesmenRisikoJatuhPage from "@/components/pemeriksaan/assesmen/AsesmenRisikoJatuhPage.vue";
import AsesmenNyeriPage from "@/components/pemeriksaan/assesmen/AsesmenNyeriPage.vue";
import SkriningBatukTabPage from "@/components/pemeriksaan/assesmen/SkriningBatukTabPage.vue";
import SkriningGiziLanjutPage from "@/components/pemeriksaan/tabs/rekam-medis/SkriningGiziLanjutPage.vue";
import SkriningBunuhDiriPage from "@/components/pemeriksaan/tabs/rekam-medis/SkriningBunuhDiriPage.vue";
import { userModule } from "@/store/modules/user";
import { storeSkriningRisikoJatuh } from "@/store/modules/skriningrisikojatuh";
import { isSkriningBunuhDiriExcluded } from "@/utils/unit";

/**
 * Konsolidasi seluruh skrining Rawat Jalan dalam satu tempat (sub-tab
 * "Skrining" di Asesmen Awal Ralan). Tiap panel me-reuse komponen yang sudah
 * ada beserta endpoint/store-nya masing-masing — tidak ada perubahan backend.
 *
 * Mayoritas komponen memuat datanya sendiri di mounted (lazy saat panel
 * dibuka). Khusus CardSkriningRisikoJatuh bergantung pada store yang di-load
 * parent, jadi di-dispatch di sini.
 */
@Component({
  components: {
    CardSkriningRisikoJatuh,
    AsesmenRisikoJatuhPage,
    AsesmenNyeriPage,
    SkriningBatukTabPage,
    SkriningGiziLanjutPage,
    SkriningBunuhDiriPage
  }
})
export default class SkriningRawatJalanPage extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;

  // Panel pertama (Skrining Risiko Jatuh) terbuka secara default.
  panels = [0];

  get showSkriningBunuhDiri(): boolean {
    return !isSkriningBunuhDiriExcluded(
      userModule.segmentUnitId,
      userModule.loginUnitId
    );
  }

  mounted() {
    const getparam = {
      unit_id: userModule.user.unit_id,
      reg: this.register
    };
    storeSkriningRisikoJatuh.actRisikoJatuhByUnitAndReg(getparam);
    storeSkriningRisikoJatuh.actRisikoJatuhByRm(this.rm);
  }
}
